import PanelViewFactory from './PanelViewFactory'

export default PanelViewFactory
